import type { SVGProps } from 'react';

export function HeartIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 21s-6.5-5.5-9-9C1.5 7.5 3.5 4 7 4c2.1 0 3.5 1.5 5 3.5C13.5 5.5 14.9 4 17 4c3.5 0 5.5 3.5 4 8-2.5 3.5-9 9-9 9z" />
    </svg>
  );
}
